import { API_BASE as API_BASE_URL } from "./base";
import {
  appendSuperAdminReportLocationFilters,
  withSuperAdminReportLocationFilters,
} from "../utils/superAdminReportLocationFilters";

function getAuthHeaders() {
  const token = null;
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function parseJson(res) {
  const text = await res.text();
  if (!res.ok) {
    let payload = null;
    if (text) {
      try {
        payload = JSON.parse(text);
      } catch (error) {
        payload = null;
      }
    }
    const detail =
      (payload && typeof payload.detail === "string" && payload.detail) ||
      text ||
      `Request failed with status ${res.status}`;
    const err = new Error(detail);
    err.status = res.status;
    err.payload = payload;
    throw err;
  }
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch (error) {
    return text;
  }
}

function buildQuery(params = {}) {
  const query = appendSuperAdminReportLocationFilters(new URLSearchParams());
  if (params.scope) query.set("scope", String(params.scope));
  if (params.business_id != null && params.business_id !== "") {
    query.set("business_id", String(params.business_id));
  }
  if (params.salon_id != null && params.salon_id !== "") {
    query.set("salon_id", String(params.salon_id));
  }
  return query.toString();
}

export async function getSuperAdminBreakEvenSensitivityFilters(params = {}) {
  const query = buildQuery(params);
  const url = `${API_BASE_URL}/superadmin/reports/break-even-sensitivity/filters${
    query ? `?${query}` : ""
  }`;
  const res = await fetch(url, { headers: getAuthHeaders() });
  return parseJson(res);
}

export async function getSuperAdminBreakEvenSensitivityConfig(salonId) {
  const query = new URLSearchParams();
  query.set("salon_id", String(salonId));
  const res = await fetch(
    `${API_BASE_URL}/superadmin/reports/break-even-sensitivity/config?${query.toString()}`,
    { headers: getAuthHeaders() }
  );
  return parseJson(res);
}

export async function updateSuperAdminBreakEvenSensitivityConfig(salonId, payload = {}) {
  const query = new URLSearchParams();
  query.set("salon_id", String(salonId));
  const res = await fetch(
    `${API_BASE_URL}/superadmin/reports/break-even-sensitivity/config?${query.toString()}`,
    {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    }
  );
  return parseJson(res);
}

export async function runSuperAdminBreakEvenSensitivityReport(payload = {}) {
  const res = await fetch(`${API_BASE_URL}/superadmin/reports/break-even-sensitivity/run`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(withSuperAdminReportLocationFilters(payload)),
  });
  return parseJson(res);
}
